import { render } from "./AgendaItem.vue?vue&type=template&id=ffd80a3c"
import script from "./AgendaItem.vue?vue&type=script&lang=js"
export * from "./AgendaItem.vue?vue&type=script&lang=js"

import "./AgendaItem.vue?vue&type=style&index=0&id=ffd80a3c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__